import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import BaseRule from '../BaseRule.vue';
import { computed } from 'vue';
export default {
  __name: 'TotalManage',
  props: ['index', 'data'],
  setup(__props) {
    const props = __props;
    const index = computed(() => props.index);
    const data = computed(() => props.data);
    const word = {
      first: '累计开票月数大于等于',
      second: '月',
      name: 'TotalManage'
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(BaseRule, {
        word: word,
        index: _unref(index),
        data: _unref(data)
      }, null, 8, ["index", "data"]);
    };
  }
};